// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"9a9bd64ec285abe2ccdf","147":"115175f4d0bff833e08c","251":"dad3d35b452fa82bc845","352":"5d87913e3e55d5a26a3b","631":"7f6481807ea5020ff807"}[chunkId] + ".js";
};